import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';

import ChangePassword from '../containers/MemberPassword/ChangePassword';
import RecoverPassword from '../containers/RecoverPassword';
import ErrorMessage from '../containers/ErrorMessage';

const Routes: React.FC = () => {
  return (
    <div className="vbz-lf">
      <Router>
        <Switch>
          <Route exact path={'/minha-conta/alterar-senha'} component={ChangePassword} />
          <Route exact path={'/recuperar/senha'} component={RecoverPassword} />
          <Route exact path={'/minha-conta/erro'} component={ErrorMessage} />
        </Switch>
      </Router>
    </div>
  );
};

export default Routes;
